/**
 * External Imports
 */
import { FC } from 'react';
import { connect, useDispatch } from 'react-redux';

/**
 * Nexus Imports
 */
import { NeuButton } from '@neutron/react';

/**
 * Internal Imports
 */
import { RootState } from '../../../../redux/store';
import {
  openModal,
  setModalType,
  setModalData
} from '../../../../redux/actions';

/**
 * Global Type Definition Imports
 */
import { Patient, Employee } from '../../../../config/interfaces';

interface AddIssueFromRoundProps {
  modalData: Patient | Employee;
  type: string;
}
const AddIssueFromRound: FC<AddIssueFromRoundProps> = ({ modalData, type }) => {
  const dispatch = useDispatch();

  const addNewIssue = () => {
    if (type === 'patient') {
      dispatch(setModalType('Add Patient Issue On Rounds'));
      dispatch(setModalData(modalData));
      dispatch(openModal());
    } else if (type === 'employee') {
      dispatch(setModalType('Add Employee Issue On Rounds'));
      dispatch(setModalData(modalData));
      dispatch(openModal());
    } else {
      dispatch(setModalType('Add Support Issue On Rounds'));
      dispatch(setModalData(modalData));
      dispatch(openModal());
    }
  };

  return (
    <NeuButton
      data-testid="add-issue-from-round-button"
      className="mx-2"
      color="blue"
      icon="flag"
      kind="secondary"
      size="small"
      onClick={addNewIssue}
    >
      Add issue
    </NeuButton>
  );
};

const mapReduxStateToProps = (state: RootState) => {
  return {
    authorizedUser: state.AuthorizedUser.authorizedUser,
    modalState: state.ModalReducer.modal
  };
};

export default connect(mapReduxStateToProps)(AddIssueFromRound);
